import logo from "./logo.svg";
import "./index.css";

/* ═══════════════════════════════════════════
   SVG Icons (inline for zero dependencies)
   ═══════════════════════════════════════════ */
const Icon = ({
	children,
	className = "size-5",
}: {
	children: React.ReactNode;
	className?: string;
}) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		aria-hidden="true"
	>
		{children}
	</svg>
);

const icons = {
	briefcase: (
		<>
			<rect x="2" y="7" width="20" height="14" rx="2" />
			<path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
		</>
	),
	coins: (
		<>
			<circle cx="8" cy="8" r="6" />
			<path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
			<path d="M7 6h1v4" />
			<path d="m16.71 13.88.7.71-2.82 2.82" />
		</>
	),
	calendar: (
		<>
			<rect x="3" y="4" width="18" height="18" rx="2" />
			<line x1="16" y1="2" x2="16" y2="6" />
			<line x1="8" y1="2" x2="8" y2="6" />
			<line x1="3" y1="10" x2="21" y2="10" />
		</>
	),
	building: (
		<>
			<rect x="4" y="2" width="16" height="20" rx="2" />
			<path d="M9 22v-4h6v4" />
			<path d="M8 6h.01M16 6h.01M12 6h.01M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01" />
		</>
	),
	file: (
		<>
			<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
			<polyline points="14,2 14,8 20,8" />
			<line x1="16" y1="13" x2="8" y2="13" />
			<line x1="16" y1="17" x2="8" y2="17" />
			<line x1="10" y1="9" x2="8" y2="9" />
		</>
	),
	shield: (
		<>
			<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
			<polyline points="9,12 11,14 15,10" />
		</>
	),
	pin: (
		<>
			<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
			<circle cx="12" cy="10" r="3" />
		</>
	),
	mail: (
		<>
			<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
			<polyline points="22,6 12,13 2,6" />
		</>
	),
	phone: (
		<>
			<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.1 9.92a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
		</>
	),
	globe: (
		<>
			<circle cx="12" cy="12" r="10" />
			<path d="M2 12h20" />
			<path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
		</>
	),
	externalLink: (
		<>
			<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
			<polyline points="15,3 21,3 21,9" />
			<line x1="10" y1="14" x2="21" y2="3" />
		</>
	),
};

/* ═══════════════════════════════════════════
   Company Data
   ═══════════════════════════════════════════ */
const company = {
	name: "ACCOUNTING COVER ΙΔΙΩΤΙΚΗ ΚΕΦΑΛΑΙΟΥΧΙΚΗ ΕΤΑΙΡΕΙΑ",
	tradeName: "ACCOUNTING COVER I.K.E.",
	tradeNameEn: "ACCOUNTING COVER P.C.",
	gemi: "157994301000",
	afm: "801496953",
	legalForm: "ΙΚΕ",
	status: "Ενεργή",
	foundingDate: "01/02/2021",
	chamber: "ΕΜΠΟΡΙΚΟ & ΒΙΟΜΗΧΑΝΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ ΑΘΗΝΩΝ",
	address: {
		street: "ΤΣΟΥΔΕΡΟΥ 5",
		city: "ΑΛΙΜΟΣ",
		postalCode: "17455",
		region: "ΑΤΤΙΚΗΣ",
	},
	email: "accountingcover@mail.com",
	phone: "6936841001",
	capital: {
		shares: 1000,
		guarantee: 0,
		total: 1000,
		type: "Κεφαλαιακές",
	},
	partners: [
		{
			name: "ΣΑΚΕΛΛΑΡΙΟΣ ΧΑΡΑΛΑΜΠΟΣ",
			initials: "ΣΧ",
			role: "Εταίρος",
			share: "51%",
			contributionType: "Κεφαλαιακή",
			address: "ΤΣΟΥΔΕΡΟΥ 5, ΑΛΙΜΟΣ, 17455",
		},
		{
			name: "ΣΑΚΕΛΛΑΡΙΟΣ ΠΑΝΑΓΙΩΤΗΣ",
			initials: "ΣΠ",
			role: "Εταίρος & Διαχειριστής",
			share: "49%",
			contributionType: "Κεφαλαιακή",
			address: "ΤΣΟΥΔΕΡΟΥ 5, ΑΛΙΜΟΣ, 17455",
		},
	],
	activities: [
		{ code: "69201100", desc: "Υπηρεσίες Λογιστικής Τήρησης Βιβλίων" },
		{ code: "69201200", desc: "Υπηρεσίες Κατάρτισης Οικονομικών Καταστάσεων" },
		{ code: "69201300", desc: "Υπηρεσίες Μισθοδοσίας" },
		{ code: "69202000", desc: "Υπηρεσίες Φορολογικών Συμβούλων" },
		{
			code: "69203000",
			desc: "Υπηρεσίες Σε Θέματα Αφερεγγυότητας Και Εκκαθάρισης",
		},
		{
			code: "62020000",
			desc: "Δραστηριότητες Παροχής Συμβουλών Σε Θέματα Πληροφορικής",
		},
		{
			code: "70220000",
			desc: "Δραστηριότητες Παροχής Επιχειρηματικών Συμβουλών",
		},
		{ code: "82110000", desc: "Υπηρεσίες Γενικής Γραμματειακής Υποστήριξης" },
		{
			code: "82190000",
			desc: "Φωτοτυπίες, Προετοιμασία Εγγράφων Και Άλλες Ειδικές Δραστηριότητες",
		},
	],
	mainActivity: "Υπηρεσίες Λογιστικής Τήρησης Βιβλίων",
	gemiUrl: "https://publicity.businessportal.gr/company/157994301000",
};

/* ═══════════════════════════════════════════
   Sub-components
   ═══════════════════════════════════════════ */

/* ── Badge ── */
function Badge({ label, color }: { label: string; color?: string }) {
	return (
		<span
			className="glass inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em]"
			style={{ color: color || "var(--color-accent)" }}
		>
			{label}
		</span>
	);
}

/* ── Status Badge ── */
function StatusBadge() {
	return (
		<span
			className="glass inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em]"
			style={{ color: "#22c55e" }}
		>
			<span
				className="size-1.5 rounded-full pulse-dot"
				style={{ background: "#22c55e" }}
			/>
			{company.status}
		</span>
	);
}

/* ── Section Header ── */
function SectionHeader({
	badge,
	title,
	subtitle,
}: {
	badge: string;
	title: string;
	subtitle: string;
}) {
	return (
		<div className="mb-10 text-center">
			<Badge label={badge} />
			<h2
				className="mt-4 gradient-text font-[var(--font-serif)] text-3xl font-semibold leading-tight sm:text-4xl md:text-5xl"
				style={{ fontFamily: "var(--font-serif)" }}
			>
				{title}
			</h2>
			<p className="mx-auto mt-3 max-w-2xl text-sm text-white/60 sm:text-base">
				{subtitle}
			</p>
		</div>
	);
}

/* ── Info Card ── */
function InfoCard({
	icon,
	label,
	value,
	mono,
	large,
	sub,
}: {
	icon: React.ReactNode;
	label: string;
	value: string;
	mono?: boolean;
	large?: boolean;
	sub?: string;
}) {
	return (
		<div className="glass card-lift rounded-3xl p-6 text-center">
			<div
				className="mx-auto mb-4 flex size-12 items-center justify-center rounded-2xl"
				style={{
					background:
						"color-mix(in srgb, var(--color-accent) 20%, transparent)",
					color: "var(--color-accent)",
				}}
			>
				<Icon>{icon}</Icon>
			</div>
			<div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-white/50">
				{label}
			</div>
			<div
				className={`mt-1 break-words font-semibold ${large ? "text-2xl" : "text-base"} ${mono ? "font-mono" : ""}`}
				style={large ? { fontFamily: "var(--font-serif)" } : undefined}
			>
				{value}
			</div>
			{sub && <div className="mt-1 text-xs text-white/50">{sub}</div>}
		</div>
	);
}

/* ── Contact Card ── */
function ContactCard({
	icon,
	label,
	value,
	href,
}: {
	icon: React.ReactNode;
	label: string;
	value: string;
	href?: string;
}) {
	const inner = (
		<div className="glass flex items-center gap-4 rounded-2xl p-4 sm:p-5 transition">
			<div
				className="flex size-11 shrink-0 items-center justify-center rounded-xl"
				style={{
					background:
						"color-mix(in srgb, var(--color-accent) 20%, transparent)",
					color: "var(--color-accent)",
				}}
			>
				<Icon>{icon}</Icon>
			</div>
			<div className="min-w-0 flex-1">
				<div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-white/50">
					{label}
				</div>
				<div className="mt-0.5 truncate text-sm font-semibold text-white">
					{value}
				</div>
			</div>
			{href && href.startsWith("http") && (
				<Icon className="size-4 text-white/40">{icons.externalLink}</Icon>
			)}
		</div>
	);

	if (href) {
		const isExternal = href.startsWith("http");
		return (
			<a
				href={href}
				className="block card-lift"
				{...(isExternal
					? { target: "_blank", rel: "noopener noreferrer" }
					: {})}
			>
				{inner}
			</a>
		);
	}
	return inner;
}

/* ═══════════════════════════════════════════
   Main Page
   ═══════════════════════════════════════════ */
export function App() {
	return (
		<main className="premium-bg relative min-h-screen overflow-hidden bg-[#0A0B10] text-white">
			{/* ── Header ── */}
			<header
				id="header"
				className="sticky top-0 z-40 border-b border-white/10 bg-[#0A0B10]/70 backdrop-blur-xl"
			>
				<div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:px-6">
					<div className="flex min-w-0 items-center gap-2.5">
						{/* Logo */}
						<img src={logo} className="size-8" alt="Logo" />
						<span className="truncate text-sm font-semibold sm:text-base">
							{company.tradeName}
						</span>
					</div>
				</div>
			</header>

			{/* ── Hero ── */}
			<section id="hero" className="relative">
				<div className="mx-auto max-w-6xl px-4 py-20 text-center sm:px-6 sm:py-28">
					<StatusBadge />

					<h1
						className="mx-auto mt-6 max-w-4xl gradient-text text-[36px] font-semibold leading-[1.05] tracking-tight sm:text-6xl md:text-7xl break-words"
						style={{ fontFamily: "var(--font-serif)" }}
					>
						{company.name}
					</h1>

					<p className="mt-4 text-base italic text-white/50 sm:text-lg">
						{company.tradeNameEn}
					</p>

					<p className="mx-auto mt-5 max-w-2xl text-sm text-white/60 sm:text-base">
						{company.mainActivity}
					</p>

					{/* Key numbers */}
					<div className="mx-auto mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/50 sm:text-sm">
						<span className="inline-flex items-baseline gap-1.5">
							<span className="text-white/40">ΓΕΜΗ</span>
							<strong className="font-medium font-mono text-white">
								{company.gemi}
							</strong>
						</span>
						<span className="inline-flex items-baseline gap-1.5">
							<span className="text-white/40">ΑΦΜ</span>
							<strong className="font-medium font-mono text-white">
								{company.afm}
							</strong>
						</span>
						<span className="inline-flex items-baseline gap-1.5">
							<span className="text-white/40">Ενεργή από</span>
							<strong className="font-medium text-white">
								{company.foundingDate}
							</strong>
						</span>
					</div>

					{/* CTA buttons */}
					<div className="mt-10 flex flex-wrap items-center justify-center gap-3">
						<a
							href={`mailto:${company.email}`}
							id="cta-email"
							className="inline-flex items-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-2xl transition hover:brightness-110"
							style={{
								background: "linear-gradient(135deg, #2563eb, #8b5cf6)",
								boxShadow: "0 8px 30px rgba(37, 99, 235, 0.25)",
							}}
						>
							<Icon className="size-4">{icons.mail}</Icon>
							Αποστολή Email
						</a>
						<a
							href={`tel:${company.phone}`}
							id="cta-phone"
							className="glass inline-flex items-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold text-white transition"
						>
							<Icon className="size-4">{icons.phone}</Icon>
							{company.phone}
						</a>
					</div>
				</div>
			</section>

			{/* ── ΓΕΜΗ Data Cards ── */}
			<section id="gemi-data" className="reveal py-20 sm:py-24">
				<div className="mx-auto max-w-6xl px-4 sm:px-6">
					<SectionHeader
						badge="Στοιχεία"
						title="Επίσημα στοιχεία ΓΕΜΗ"
						subtitle="Αυτόματα συγχρονισμένα από το Γενικό Εμπορικό Μητρώο."
					/>

					<div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
						<InfoCard
							icon={icons.briefcase}
							label="Νομική Μορφή"
							value={company.legalForm}
						/>
						<InfoCard
							icon={icons.coins}
							label="Εταιρικό Κεφάλαιο"
							value="1.000 €"
							large
							sub={company.capital.type}
						/>
						<InfoCard
							icon={icons.calendar}
							label="Ημ. Σύστασης"
							value={company.foundingDate}
						/>
						<InfoCard
							icon={icons.building}
							label="Επιμελητήριο"
							value={company.chamber}
						/>
						<InfoCard
							icon={icons.file}
							label="ΓΕΜΗ"
							value={company.gemi}
							mono
						/>
						<InfoCard
							icon={icons.shield}
							label="ΑΦΜ"
							value={company.afm}
							mono
						/>
					</div>

					{/* Address row */}
					<div className="glass mt-4 rounded-3xl p-6 sm:p-7">
						<div className="flex items-start gap-5">
							<div
								className="flex size-12 shrink-0 items-center justify-center rounded-2xl"
								style={{
									background:
										"color-mix(in srgb, var(--color-accent) 20%, transparent)",
									color: "var(--color-accent)",
								}}
							>
								<Icon>{icons.pin}</Icon>
							</div>
							<div className="min-w-0 flex-1">
								<div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-white/50">
									Έδρα
								</div>
								<div className="mt-1 text-lg font-semibold break-words">
									{company.address.street}
								</div>
								<div className="mt-0.5 text-sm text-white/60">
									{company.address.city} · {company.address.postalCode} ·{" "}
									{company.address.region}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* ── Capital Section ── */}
			<section id="capital" className="reveal py-20 sm:py-24">
				<div className="mx-auto max-w-6xl px-4 sm:px-6">
					<SectionHeader
						badge="Οικονομικά"
						title="Εταιρικό Κεφάλαιο"
						subtitle="Αναλυτική καταγραφή εισφορών."
					/>

					<div className="glass overflow-hidden rounded-3xl">
						<div className="flex items-center justify-between border-b border-white/5 px-6 py-5">
							<div className="flex items-center gap-3">
								<span
									className="size-2 rounded-full"
									style={{
										background: "var(--color-accent)",
										boxShadow: "0 0 8px var(--color-accent)",
									}}
								/>
								<span className="text-white/70">{company.capital.type}</span>
							</div>
							<span className="font-semibold tabular-nums">1.000 €</span>
						</div>
						<div className="flex items-center justify-between border-b border-white/5 px-6 py-5">
							<div className="flex items-center gap-3">
								<span className="size-2 rounded-full bg-white/20" />
								<span className="text-white/70">Εγγυητικές εισφορές</span>
							</div>
							<span className="font-semibold tabular-nums">€0</span>
						</div>
						<div className="flex items-center justify-between bg-white/5 px-6 py-5">
							<span className="font-semibold">Σύνολο</span>
							<span
								className="gradient-accent text-2xl font-semibold tabular-nums"
								style={{ fontFamily: "var(--font-serif)" }}
							>
								1.000 €
							</span>
						</div>
					</div>
				</div>
			</section>

			{/* ── Partners ── */}
			<section id="partners" className="reveal py-20 sm:py-24">
				<div className="mx-auto max-w-6xl px-4 sm:px-6">
					<SectionHeader
						badge="Εταίροι"
						title="Εταίροι & Διαχείριση"
						subtitle="Ιδιωτική Κεφαλαιουχική Εταιρεία."
					/>

					<div className="grid gap-4 md:grid-cols-2">
						{company.partners.map((p) => (
							<div key={p.name} className="glass rounded-3xl p-6">
								<div className="flex items-start gap-4">
									<div
										className="flex size-12 shrink-0 items-center justify-center rounded-2xl text-sm font-semibold text-white shadow-lg"
										style={{
											background: "linear-gradient(135deg, #2563eb, #8b5cf6)",
										}}
									>
										{p.initials}
									</div>
									<div className="min-w-0 flex-1">
										<div className="text-base font-semibold break-words">
											{p.name}
										</div>
										<div
											className="mt-0.5 inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium"
											style={{
												background:
													"color-mix(in srgb, var(--color-accent) 18%, transparent)",
												color: "var(--color-accent)",
											}}
										>
											{p.role}
										</div>
										<div className="mt-3 space-y-1 text-sm text-white/60">
											<div>
												Συμμετοχή{" "}
												<strong className="text-white">{p.share}</strong>
											</div>
											<div>
												Εισφορά{" "}
												<span className="rounded-md bg-white/10 px-2 py-0.5 text-xs text-white">
													{p.contributionType}
												</span>
											</div>
											<div>
												Διεύθυνση{" "}
												<span className="text-white">{p.address}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>

					<p className="mt-4 text-center text-[11px] text-white/40">
						Η συμμετοχή και ο ρόλος προέρχονται από το επίσημο μητρώο ΓΕΜΗ.
					</p>
				</div>
			</section>

			{/* ── Activities ── */}
			<section id="activities" className="reveal py-20 sm:py-24">
				<div className="mx-auto max-w-6xl px-4 sm:px-6">
					<SectionHeader
						badge="Δραστηριότητες"
						title="Αντικείμενο εργασιών"
						subtitle="Κωδικοί Αριθμοί Δραστηριότητας."
					/>

					<div className="flex flex-wrap justify-center gap-2">
						{company.activities.map((a) => (
							<div
								key={a.code}
								className="glass rounded-full px-4 py-2 text-sm"
							>
								<span className="mr-2 font-mono text-xs text-white/40">
									{a.code}
								</span>
								{a.desc}
							</div>
						))}
					</div>
				</div>
			</section>

			{/* ── Contact ── */}
			<section id="contact" className="relative">
				<div className="mx-auto grid max-w-6xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:py-24">
					<div>
						<Badge label="Επικοινωνία" color="var(--color-accent)" />
						<h2
							className="mt-5 gradient-text text-4xl font-semibold leading-tight sm:text-5xl"
							style={{ fontFamily: "var(--font-serif)" }}
						>
							Ας μιλήσουμε
						</h2>
						<p className="mt-4 max-w-md text-white/60">
							Επικοινωνήστε για οποιαδήποτε ερώτηση ή συνεργασία.
						</p>
						<a
							href={`mailto:${company.email}`}
							id="contact-email-cta"
							className="mt-6 inline-flex items-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-2xl transition hover:brightness-110"
							style={{
								background: "linear-gradient(135deg, #2563eb, #8b5cf6)",
								boxShadow: "0 8px 30px rgba(37, 99, 235, 0.25)",
							}}
						>
							<Icon className="size-4">{icons.mail}</Icon>
							Αποστολή Email
						</a>
					</div>

					<div className="space-y-3">
						<ContactCard
							icon={icons.phone}
							label="Τηλέφωνο"
							value={company.phone}
							href={`tel:${company.phone}`}
						/>
						<ContactCard
							icon={icons.mail}
							label="Email"
							value={company.email}
							href={`mailto:${company.email}`}
						/>
						<ContactCard
							icon={icons.pin}
							label="Διεύθυνση"
							value={`${company.address.street}, ${company.address.city}, ${company.address.postalCode}`}
						/>
						<ContactCard
							icon={icons.shield}
							label="Επίσημη ΓΕΜΗ"
							value="publicity.businessportal.gr"
							href={company.gemiUrl}
						/>
					</div>
				</div>
			</section>

			{/* ── Footer ── */}
			<footer id="footer" className="border-t border-white/10 py-6">
				<div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-3 px-4 text-xs text-white/50 sm:flex-row sm:items-center sm:px-6">
					<div className="flex flex-wrap items-center gap-x-3 gap-y-1">
						<span>Τελευταίος συγχρονισμός μόλις τώρα</span>
					</div>
					<div className="flex flex-wrap items-center gap-x-3">
						<span>© 2025 {company.tradeName}</span>
						<span>·</span>
						<span>
							Συμμόρφωση{" "}
							<span className="font-medium">Ν.4072/2012 Άρθρο 47 §2</span>
						</span>
					</div>
				</div>
			</footer>
		</main>
	);
}

export default App;
